<div
  fxLayout="row"
  fxLayoutAlign="center start"
  class="centered-container"
  fxFlexFill
>
  <mat-card
    class="signup-card mat-elevation-z4"
    ngClass.gt-cs="larger-margins"
    fxLayout="column"
    fxLayoutAlign="space-around stretch"
    fxFlex="100"
    fxFlex.gt-xs="50"
  >
    <h1 class="title">Register with Email</h1>
    <form
      [formGroup]="form"
      class="signup-form"
      fxLayout="column"
      fxLayoutAlign="start center"
      (ngSubmit)="signUp()"
    >
      <mat-form-field fxFill class="form-field">
        <mat-label>Full Name</mat-label>
        <input matInput formControlName="displayName" />
        <mat-icon matSuffix>person</mat-icon
        ><mat-error *ngIf="form.get('displayName')?.hasError('required')">
          Full Name is required.
        </mat-error>
      </mat-form-field>
      <mat-form-field fxFill class="form-field">
        <mat-label>Email Address</mat-label>
        <input matInput formControlName="email" /><mat-error
          *ngIf="form.get('email')?.hasError('required')"
        >
          Email Address is required. </mat-error
        ><mat-error *ngIf="form.get('email')?.hasError('email')">
          Please enter a valid email address.
        </mat-error>
        <mat-icon matSuffix>email</mat-icon>
      </mat-form-field>
      <mat-form-field fxFill class="form-field">
        <mat-label>Password</mat-label>
        <input
          matInput
          formControlName="password"
          suggested="new-password"
          type="password"
        />
        <mat-icon matSuffix>lock</mat-icon
        ><mat-error *ngIf="form.get('password')?.hasError('required')">
          Password is required.
        </mat-error>
      </mat-form-field>
      <mat-form-field fxFill class="form-field">
        <mat-label>Confirm Password</mat-label>
        <input
          matInput
          formControlName="passwordConfirm"
          suggested="new-password"
          type="password"
        />

        <mat-icon matSuffix>lock</mat-icon
        ><mat-error *ngIf="form.get('passwordConfirm')?.hasError('required')">
          Please confirm your password. </mat-error
        ><mat-error
          *ngIf="
            !form.get('passwordConfirm')?.hasError('required') &&
            form.get('passwordConfirm')?.hasError('passwordsNotMatching')
          "
        >
          Password must match.
        </mat-error>
      </mat-form-field>
      <button
        class="form-button"
        mat-raised-button
        [class.spinner]="loading"
        [disabled]="loading"
        fxFill
        color="primary"
        type="submit"
      >
        Register
      </button>
    </form>
    <div>
      Already have an account?
      <a routerLink="../">Login Menu</a>
    </div>
    <div>
      Don't have an email address?
      <a routerLink="..">Register with another provider.</a>
    </div>
  </mat-card>
</div>
